export { Caption2Strong } from './Caption2Strong';
export { caption2StrongClassNames } from './useCaption2StrongStyles.styles';
